var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandlestickChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#00CBAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9432_87821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68896 2.66602V4.79935V5.51046V8.3549H8.40008V5.51046V4.79935V2.66602H7.68896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1333 5.51074V6.22185V6.93296V9.0663V9.77741V11.1996H4.84441V9.77741V9.0663V6.93296V6.22185V5.51074H4.1333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 6.93216V6.22105V4.79883H11.2448V6.22105V6.93216V9.0655V9.77661V11.1988H10.5337V9.77661V9.0655V6.93216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.48903,
    cy: 8.71022,
    rx: 1.06667,
    ry: 1.06667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.04469,
    cy: 5.15456,
    rx: 1.06667,
    ry: 1.06667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8889,
    cy: 8.71022,
    r: 1.06667,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9432_87821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(2 3.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandlestickChartIcon);
export default __webpack_public_path__ + "static/media/candlestick-chart-icon.aeb862a66f5b95a375bed9fc45370efa.svg";
export { ForwardRef as ReactComponent };